import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  devices: [],
  devicesByProvider: []
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.RELOAD_PROVIDER_DATA: {
      return { ...state, devices: [], devicesByProvider: [] };
    }
    // What <KioskDeviceStatus> reads: one flat list keyed by device uuid.
    case AT.FETCH_IOT_DEVICE_STATUS_DONE: {
      return { ...state, devices: action.devices };
    }
    case AT.FETCH_DEVICE_STATUSES_DONE: {
      const { devices, serviceProvider } = action;
      const statusIndex = R.findIndex(R.propEq(serviceProvider.id, 'serviceProviderId'))(state.devicesByProvider);
      const obj = { serviceProviderId: serviceProvider.id, serviceProvider: serviceProvider, devices };
      if (statusIndex === -1) {
        return { ...state, devicesByProvider: R.append(obj)(state.devicesByProvider) };
      }
      return { ...state, devicesByProvider: R.update(statusIndex, obj)(state.devicesByProvider) };
    }
    default: {
      return state;
    }
  }
}
